import React from 'react';

import './TooltipContentConfidence.scss';

function TooltipContentFD() {
  return (
    <div className="rs-tooltip-big__content info-tooltip-content tooltip-content-confidence">
      <div>
        The <b>First disconnection</b> column shows the project molecule for each route (row).
      </div>
      <li className="info-tooltip-content-list-item bullet-dot">
        Each route may start the retrosynthesis with a different disconnection strategy.
      </li>
      <li className="info-tooltip-content-list-item bullet-dot">
        The molecules displayed in this column contain highlights for the atoms and bonds that are reaction centers for this first
        disconnection step.
      </li>
      <li className="info-tooltip-content-list-item bullet-dot">
        This makes it easier for you to quickly recognize the different strategies and to decide which retrosynthesis route to look into
        further.
      </li>
    </div>
  );
}

export default TooltipContentFD;
